/**
 * @class Converter
 * Just an simple TS module
 */

export interface IConverter {
  conversionVal: number;
  convertMToInch(value: number): number;
}

export class Converter implements IConverter {
  conversionVal = 39.37;

  convertMToInch(value: number) {
    // multiplying and dividing by 100 to fix floating point bug with JavaScript
    return (value * 100) / this.conversionVal / 100;
  }
}

export const feetToMeterConverter = (value: number): number => {
  return value / 3.2808;
};

export const meterToFeetConverter = (value: number): number => {
  return value * 3.2808;
};

export const meterToKilometerConverter = (value: number): number => {
  return value / 1000;
};

export const metersPerSecondToKnotsConverter = (value: number): number => {
  return value * 1.94384;
};

// change infringementTypes acronyms to
export const letterCaseFormat = (key: string, value: string) => {
  if (key === 'infringementTypes') {
    switch (value) {
      case 'CCO':
        return 'Cco';
      case 'CDO':
        return 'Cdo';
      default:
        return value;
    }
  }
  return value;
};
